import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { HiOutlineArrowLeft } from 'react-icons/hi2';
import { workPermitService } from '../services';
import PageLoading from '../components/common/PageLoading';
import './Reports.css';

const WorkPermitExpiringReport = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [filters, setFilters] = useState({ hoursAhead: 24 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const loadData = async () => {
    try {
      setLoading(true);
      setError('');
      const rows = await workPermitService.getExpiringPermits(filters.hoursAhead || 24);
      setData(rows || []);
    } catch (err) {
      console.error(err);
      setError('Failed to load expiring permits.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className="pagecontainer reports-page">
      <div className="page-header">
        <div className="header-content">
          <div className="report-title-section">
            <button className="back-btn" onClick={() => navigate("/home/reports")} title="Back to Reports Dashboard">
              <HiOutlineArrowLeft />
            </button>
            <h1>Work Permit Expiring Report</h1>
          </div>
          <p>Permits expiring within the selected window.</p>
        </div>
        <div className="reports-actions">
          <button className="btn-secondary" onClick={loadData}>Refresh</button>
        </div>
      </div>

      <div className="reports-filters workreport-filters">
        <div className="form-group">
          <label>Hours Ahead</label>
          <input type="number" name="hoursAhead" value={filters.hoursAhead} onChange={handleChange} min="1" />
        </div>
        <button className="btn-primary" onClick={loadData}>Apply</button>
      </div>

      {error && <div className="error-message">{error}</div>}
      {loading ? (
        <PageLoading message="Loading report…" />
      ) : (
        <div className="reports-table">
          <table>
            <thead>
              <tr>
                <th>Permit #</th>
                <th>Type</th>
                <th>Status</th>
                <th>Equipment</th>
                <th>Valid To</th>
              </tr>
            </thead>
            <tbody>
              {data.length === 0 && (
                <tr><td colSpan="5" className="empty-state">No expiring permits.</td></tr>
              )}
              {data.map((p) => (
                <tr key={p.permitId}>
                  <td>{p.permitNumber}</td>
                  <td>{p.permitTypeName || '-'}</td>
                  <td>{p.status}</td>
                  <td>{p.equipmentName || '-'}</td>
                  <td>{p.validTo ? new Date(p.validTo).toLocaleString() : '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default WorkPermitExpiringReport;

